import React, { Component } from "react";

class LastSavedStatus extends Component {
  formatUpdatedAtTime = () => {
    const { updatedAt } = this.props;

    if (!updatedAt) return "Not saved yet";

    let updatedAtDate;
    try {
      updatedAtDate = updatedAt.toDate
        ? updatedAt.toDate()
        : new Date(updatedAt);
    } catch (e) {
      return "Invalid date";
    }

    if (isNaN(updatedAtDate.getTime())) return "Invalid date";

    const now = new Date();
    const diffMs = now - updatedAtDate;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffMonth = Math.floor(diffDay / 30);
    const diffYear = Math.floor(diffDay / 365);

    if (diffSec < 60) return "Just Now";
    if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? "" : "s"} ago`;
    if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? "" : "s"} ago`;
    if (diffDay === 1) return "yesterday";
    if (diffDay < 30) return `${diffDay} day${diffDay === 1 ? "" : "s"} ago`;
    if (diffMonth < 12)
      return `${diffMonth} month${diffMonth === 1 ? "" : "s"} ago`;
    return `${diffYear} year${diffYear === 1 ? "" : "s"} ago`;
  };

  render() {
    const { updatedAt, theme } = this.props;
    const lastSaved = this.formatUpdatedAtTime();

    return (
      <div className="col-md-6 text-end">
        <p
          className="small"
          style={{
            backgroundColor: theme.colors.gradient,
            color: theme.colors.text,
            padding: "5px 10px",
            borderRadius: "5px",
            display: "inline-block",
          }}
        >
          {updatedAt
            ? `Blog last saved: ${lastSaved}`
            : "Blog has not been saved yet."}
        </p>
      </div>
    );
  }
}

export default LastSavedStatus;
